import { USE_MOCKS } from '~/shared/config'

import { registerUserMocks } from './mocks'

export { UserQuery } from './UserQuery'
// `MeQuery` — алиас `UserQuery` для слайсов, которым естественнее «мой профиль» (GET /users/me),
// например modules/natal. Тот же запрос, тот же кэш-ключ — просто другое имя на публичной границе.
export { UserQuery as MeQuery } from './UserQuery'
export { UpdateUserMutation } from './UpdateUserMutation'
export type { UpdateUserInput } from './UpdateUserMutation'
export { UpdateBirthMutation } from './UpdateBirthMutation'
export type { UpdateBirthInput } from './UpdateBirthMutation'
export { UpdateSettingsMutation } from './UpdateSettingsMutation'
export type { UpdateSettingsInput } from './UpdateSettingsMutation'
export { UpdateVacationMutation } from './UpdateVacationMutation'
export type { UpdateVacationInput } from './UpdateVacationMutation'
export { CompleteOnboardingMutation } from './CompleteOnboardingMutation'
export { AcceptTermsMutation } from './AcceptTermsMutation'
export type { AcceptTermsInput } from './AcceptTermsMutation'
export { DeleteAccountMutation } from './DeleteAccountMutation'
export { SearchCitiesQuery } from './SearchCitiesQuery'
export { InvitePreviewQuery } from './InvitePreviewQuery'
export type { InvitePreviewInput } from './InvitePreviewQuery'
export { registerUserMocks, resetMockOnboarding } from './mocks'

// Самостоятельная регистрация моков при первом импорте слайса в дев-режиме — приложение сейчас
// работает полностью на моках (см. app/providers/SessionProvider), а собирать все registerXMocks()
// в единой точке бутстрапа — задача app-слоя за пределами зоны этого слайса. Идемпотентно
// (см. mocks.ts), поэтому повторный явный вызов registerUserMocks() из тестов безопасен.
if (USE_MOCKS) {
  registerUserMocks()
}
